import React, { useState, useLayoutEffect, useRef } from "react";
import gsap from "gsap";
import "./Blog.css";
import BlogPosts from "./BlogPost";

const Blog = () => {
    const categories = ["All", "Deep Learning", "Machine Learning", "AI Research"];
    const [selectedCategory, setSelectedCategory] = useState("All");
    const containerRef = useRef(null);

    useLayoutEffect(() => {
        const ctx = gsap.context(() => {
            gsap.to(".blog-hero h1, .blog-hero p", {
                y: 0,
                opacity: 1,
                duration: 1,
                stagger: 0.1,
                ease: "power3.out"
            });

            gsap.from(".category-btn", {
                y: 20,
                opacity: 0,
                duration: 0.8,
                stagger: 0.05,
                ease: "back.out(1.7)",
                delay: 0.5
            });
        }, containerRef);
        return () => ctx.revert();
    }, []);

    return (
        <div className="blog-container" ref={containerRef}>
            <section className="blog-hero">
                <h1>Insights & Analysis</h1>
                <p>Exploring the frontiers of Artificial Intelligence and Cloud Computing.</p>
            </section>

            <div className="blog-categories">
                {categories.map((category) => (
                    <button
                        key={category}
                        onClick={() => setSelectedCategory(category)}
                        className={`category-btn ${selectedCategory === category ? "active" : ""}`}
                    >
                        {category}
                    </button>
                ))}
            </div>

            <section className="blog-grid-section">
                <BlogPosts category={selectedCategory} />
            </section>
        </div>
    );
};

export default Blog;
